import type { JSX } from 'react';

import { ArrowLeftIcon, ArrowRightIcon } from '@change/ds-icons';

import { Button } from '@change/ds-core-ui/next';

type MediaHitsScrollButtonsProps = {
	onScrollLeft: () => void;
	onScrollRight: () => void;
	canScrollLeft: boolean;
	canScrollRight: boolean;
};

export function MediaHitsScrollButtons({
	onScrollLeft,
	onScrollRight,
	canScrollLeft,
	canScrollRight,
}: MediaHitsScrollButtonsProps): JSX.Element {
	return (
		<div className="ml-auto hidden flex-row gap-2 md:flex" data-testid="media-hits-scroll-buttons">
			<Button
				disabled={!canScrollLeft}
				aria-label="Scroll media hits left"
				className="h-8 w-8"
				iconOnly
				variant="secondary"
				leadingIcon={<ArrowLeftIcon className="h-4 w-4" size={16} />}
				onClick={onScrollLeft}
				data-testid="media-hits-scroll-left-button"
				data-qa="media-hits-scroll-left-button"
			/>
			<Button
				disabled={!canScrollRight}
				aria-label="Scroll media hits right"
				className="h-8 w-8"
				iconOnly
				variant="secondary"
				leadingIcon={<ArrowRightIcon className="h-4 w-4" size={16} />}
				onClick={onScrollRight}
				data-testid="media-hits-scroll-right-button"
				data-qa="media-hits-scroll-right-button"
			/>
		</div>
	);
}
